import * as React from "react";
import GlobalNav from "../components/global-nav.jsx";

const HighlightBanner = (props) => {
  return <div className="HighlightBanner">{props.children}</div>;
};

export default HighlightBanner;
